import React, { memo } from 'react';
import { DraftsIcon, MiroculusIcon, UsersIcon, Link, } from '@miroculus/nucleo';
import classnames from 'classnames/bind';
import { teamUrl } from 'cons/routes';
import styles from './Organization.scss';
const cx = classnames.bind(styles);
const TeamCard = ({ id, name, memberCount, instrumentCount, protocolCount, }) => (React.createElement("li", null,
    React.createElement(Link, { to: teamUrl(id), className: cx('team-card') },
        React.createElement("h3", null, name),
        React.createElement("div", { className: cx('team-card_content') },
            React.createElement("ul", null,
                React.createElement("li", null,
                    React.createElement(UsersIcon, null),
                    `${memberCount} Members`),
                React.createElement("li", null,
                    React.createElement(MiroculusIcon, null),
                    `${instrumentCount} Instruments`),
                React.createElement("li", null,
                    React.createElement(DraftsIcon, null),
                    `${protocolCount} Protocols`))))));
export default memo(TeamCard);
